import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../wayfinder'
/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
export const login = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

login.definition = {
    methods: ["get","head"],
    url: '/login',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
login.url = (options?: RouteQueryOptions) => {
    return login.definition.url + queryParams(options)
}

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
login.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
login.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: login.url(options),
    method: 'head',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
const loginForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
loginForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
loginForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

login.form = loginForm

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
export const logout = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

logout.definition = {
    methods: ["post"],
    url: '/logout',
} satisfies RouteDefinition<["post"]>

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
logout.url = (options?: RouteQueryOptions) => {
    return logout.definition.url + queryParams(options)
}

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
logout.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
const logoutForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: logout.url(options),
    method: 'post',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
logoutForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: logout.url(options),
    method: 'post',
})

logout.form = logoutForm

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
export const register = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: register.url(options),
    method: 'get',
})

register.definition = {
    methods: ["get","head"],
    url: '/register',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
register.url = (options?: RouteQueryOptions) => {
    return register.definition.url + queryParams(options)
}

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
register.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: register.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
register.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: register.url(options),
    method: 'head',
})

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
const registerForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: register.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
registerForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: register.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
registerForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: register.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

register.form = registerForm

/**
* @see \App\Http\Controllers\VisitorController::call
* @see app/Http/Controllers/VisitorController.php:157
* @route '/api/call'
*/
export const call = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: call.url(options),
    method: 'get',
})

call.definition = {
    methods: ["get","head"],
    url: '/api/call',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\VisitorController::call
* @see app/Http/Controllers/VisitorController.php:157
* @route '/api/call'
*/
call.url = (options?: RouteQueryOptions) => {
    return call.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\VisitorController::call
* @see app/Http/Controllers/VisitorController.php:157
* @route '/api/call'
*/
call.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: call.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\VisitorController::call
* @see app/Http/Controllers/VisitorController.php:157
* @route '/api/call'
*/
call.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: call.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\VisitorController::call
* @see app/Http/Controllers/VisitorController.php:157
* @route '/api/call'
*/
const callForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: call.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\VisitorController::call
* @see app/Http/Controllers/VisitorController.php:157
* @route '/api/call'
*/
callForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: call.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\VisitorController::call
* @see app/Http/Controllers/VisitorController.php:157
* @route '/api/call'
*/
callForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: call.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

call.form = callForm

/**
* @see \App\Http\Controllers\Api\ReservationController::reservationsGetReservedHours
* @see app/Http/Controllers/Api/ReservationController.php:67
* @route '/api/reservations/get-reserved-hours'
*/
export const reservationsGetReservedHours = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: reservationsGetReservedHours.url(options),
    method: 'get',
})

reservationsGetReservedHours.definition = {
    methods: ["get","head"],
    url: '/api/reservations/get-reserved-hours',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Api\ReservationController::reservationsGetReservedHours
* @see app/Http/Controllers/Api/ReservationController.php:67
* @route '/api/reservations/get-reserved-hours'
*/
reservationsGetReservedHours.url = (options?: RouteQueryOptions) => {
    return reservationsGetReservedHours.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\ReservationController::reservationsGetReservedHours
* @see app/Http/Controllers/Api/ReservationController.php:67
* @route '/api/reservations/get-reserved-hours'
*/
reservationsGetReservedHours.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: reservationsGetReservedHours.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\ReservationController::reservationsGetReservedHours
* @see app/Http/Controllers/Api/ReservationController.php:67
* @route '/api/reservations/get-reserved-hours'
*/
reservationsGetReservedHours.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: reservationsGetReservedHours.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Api\ReservationController::reservationsGetReservedHours
* @see app/Http/Controllers/Api/ReservationController.php:67
* @route '/api/reservations/get-reserved-hours'
*/
const reservationsGetReservedHoursForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: reservationsGetReservedHours.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\ReservationController::reservationsGetReservedHours
* @see app/Http/Controllers/Api/ReservationController.php:67
* @route '/api/reservations/get-reserved-hours'
*/
reservationsGetReservedHoursForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: reservationsGetReservedHours.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\ReservationController::reservationsGetReservedHours
* @see app/Http/Controllers/Api/ReservationController.php:67
* @route '/api/reservations/get-reserved-hours'
*/
reservationsGetReservedHoursForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: reservationsGetReservedHours.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

reservationsGetReservedHours.form = reservationsGetReservedHoursForm

/**
* @see \App\Http\Controllers\RequestController::requestShow
* @see app/Http/Controllers/RequestController.php:17
* @route '/request'
*/
export const requestShow = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: requestShow.url(options),
    method: 'get',
})

requestShow.definition = {
    methods: ["get","head"],
    url: '/request',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\RequestController::requestShow
* @see app/Http/Controllers/RequestController.php:17
* @route '/request'
*/
requestShow.url = (options?: RouteQueryOptions) => {
    return requestShow.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\RequestController::requestShow
* @see app/Http/Controllers/RequestController.php:17
* @route '/request'
*/
requestShow.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: requestShow.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\RequestController::requestShow
* @see app/Http/Controllers/RequestController.php:17
* @route '/request'
*/
requestShow.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: requestShow.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\RequestController::requestShow
* @see app/Http/Controllers/RequestController.php:17
* @route '/request'
*/
const requestShowForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: requestShow.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\RequestController::requestShow
* @see app/Http/Controllers/RequestController.php:17
* @route '/request'
*/
requestShowForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: requestShow.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\RequestController::requestShow
* @see app/Http/Controllers/RequestController.php:17
* @route '/request'
*/
requestShowForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: requestShow.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

requestShow.form = requestShowForm

/**
* @see \App\Http\Controllers\RequestController::requestStore
* @see app/Http/Controllers/RequestController.php:76
* @route '/request'
*/
export const requestStore = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: requestStore.url(options),
    method: 'post',
})

requestStore.definition = {
    methods: ["post"],
    url: '/request',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\RequestController::requestStore
* @see app/Http/Controllers/RequestController.php:76
* @route '/request'
*/
requestStore.url = (options?: RouteQueryOptions) => {
    return requestStore.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\RequestController::requestStore
* @see app/Http/Controllers/RequestController.php:76
* @route '/request'
*/
requestStore.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: requestStore.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\RequestController::requestStore
* @see app/Http/Controllers/RequestController.php:76
* @route '/request'
*/
const requestStoreForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: requestStore.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\RequestController::requestStore
* @see app/Http/Controllers/RequestController.php:76
* @route '/request'
*/
requestStoreForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: requestStore.url(options),
    method: 'post',
})

requestStore.form = requestStoreForm

/**
* @see \App\Http\Controllers\RobotsController::robots
* @see app/Http/Controllers/RobotsController.php:9
* @route '/robots.txt'
*/
export const robots = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: robots.url(options),
    method: 'get',
})

robots.definition = {
    methods: ["get","head"],
    url: '/robots.txt',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\RobotsController::robots
* @see app/Http/Controllers/RobotsController.php:9
* @route '/robots.txt'
*/
robots.url = (options?: RouteQueryOptions) => {
    return robots.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\RobotsController::robots
* @see app/Http/Controllers/RobotsController.php:9
* @route '/robots.txt'
*/
robots.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: robots.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\RobotsController::robots
* @see app/Http/Controllers/RobotsController.php:9
* @route '/robots.txt'
*/
robots.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: robots.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\RobotsController::robots
* @see app/Http/Controllers/RobotsController.php:9
* @route '/robots.txt'
*/
const robotsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: robots.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\RobotsController::robots
* @see app/Http/Controllers/RobotsController.php:9
* @route '/robots.txt'
*/
robotsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: robots.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\RobotsController::robots
* @see app/Http/Controllers/RobotsController.php:9
* @route '/robots.txt'
*/
robotsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: robots.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

robots.form = robotsForm

/**
* @see \App\Http\Controllers\SitemapController::sitemap
* @see app/Http/Controllers/SitemapController.php:12
* @route '/sitemap.xml'
*/
export const sitemap = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: sitemap.url(options),
    method: 'get',
})

sitemap.definition = {
    methods: ["get","head"],
    url: '/sitemap.xml',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SitemapController::sitemap
* @see app/Http/Controllers/SitemapController.php:12
* @route '/sitemap.xml'
*/
sitemap.url = (options?: RouteQueryOptions) => {
    return sitemap.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SitemapController::sitemap
* @see app/Http/Controllers/SitemapController.php:12
* @route '/sitemap.xml'
*/
sitemap.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: sitemap.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SitemapController::sitemap
* @see app/Http/Controllers/SitemapController.php:12
* @route '/sitemap.xml'
*/
sitemap.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: sitemap.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SitemapController::sitemap
* @see app/Http/Controllers/SitemapController.php:12
* @route '/sitemap.xml'
*/
const sitemapForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: sitemap.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SitemapController::sitemap
* @see app/Http/Controllers/SitemapController.php:12
* @route '/sitemap.xml'
*/
sitemapForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: sitemap.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SitemapController::sitemap
* @see app/Http/Controllers/SitemapController.php:12
* @route '/sitemap.xml'
*/
sitemapForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: sitemap.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

sitemap.form = sitemapForm

/**
* @see \App\Http\Controllers\VisitorController::home
* @see app/Http/Controllers/VisitorController.php:18
* @route '/'
*/
export const home = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

home.definition = {
    methods: ["get","head"],
    url: '/',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\VisitorController::home
* @see app/Http/Controllers/VisitorController.php:18
* @route '/'
*/
home.url = (options?: RouteQueryOptions) => {
    return home.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\VisitorController::home
* @see app/Http/Controllers/VisitorController.php:18
* @route '/'
*/
home.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\VisitorController::home
* @see app/Http/Controllers/VisitorController.php:18
* @route '/'
*/
home.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: home.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\VisitorController::home
* @see app/Http/Controllers/VisitorController.php:18
* @route '/'
*/
const homeForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\VisitorController::home
* @see app/Http/Controllers/VisitorController.php:18
* @route '/'
*/
homeForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\VisitorController::home
* @see app/Http/Controllers/VisitorController.php:18
* @route '/'
*/
homeForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

home.form = homeForm

/**
* @see \App\Http\Controllers\VisitorController::menu
* @see app/Http/Controllers/VisitorController.php:59
* @route '/menu'
*/
export const menu = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: menu.url(options),
    method: 'get',
})

menu.definition = {
    methods: ["get","head"],
    url: '/menu',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\VisitorController::menu
* @see app/Http/Controllers/VisitorController.php:59
* @route '/menu'
*/
menu.url = (options?: RouteQueryOptions) => {
    return menu.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\VisitorController::menu
* @see app/Http/Controllers/VisitorController.php:59
* @route '/menu'
*/
menu.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: menu.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\VisitorController::menu
* @see app/Http/Controllers/VisitorController.php:59
* @route '/menu'
*/
menu.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: menu.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\VisitorController::menu
* @see app/Http/Controllers/VisitorController.php:59
* @route '/menu'
*/
const menuForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: menu.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\VisitorController::menu
* @see app/Http/Controllers/VisitorController.php:59
* @route '/menu'
*/
menuForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: menu.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\VisitorController::menu
* @see app/Http/Controllers/VisitorController.php:59
* @route '/menu'
*/
menuForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: menu.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

menu.form = menuForm

/**
* @see \App\Http\Controllers\VisitorController::menuItemShow
* @see app/Http/Controllers/VisitorController.php:165
* @route '/menu/{slug}'
*/
export const menuItemShow = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: menuItemShow.url(args, options),
    method: 'get',
})

menuItemShow.definition = {
    methods: ["get","head"],
    url: '/menu/{slug}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\VisitorController::menuItemShow
* @see app/Http/Controllers/VisitorController.php:165
* @route '/menu/{slug}'
*/
menuItemShow.url = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { slug: args }
    }

    if (Array.isArray(args)) {
        args = {
            slug: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        slug: args.slug,
    }

    return menuItemShow.definition.url
            .replace('{slug}', parsedArgs.slug.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\VisitorController::menuItemShow
* @see app/Http/Controllers/VisitorController.php:165
* @route '/menu/{slug}'
*/
menuItemShow.get = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: menuItemShow.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\VisitorController::menuItemShow
* @see app/Http/Controllers/VisitorController.php:165
* @route '/menu/{slug}'
*/
menuItemShow.head = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: menuItemShow.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\VisitorController::menuItemShow
* @see app/Http/Controllers/VisitorController.php:165
* @route '/menu/{slug}'
*/
const menuItemShowForm = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: menuItemShow.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\VisitorController::menuItemShow
* @see app/Http/Controllers/VisitorController.php:165
* @route '/menu/{slug}'
*/
menuItemShowForm.get = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: menuItemShow.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\VisitorController::menuItemShow
* @see app/Http/Controllers/VisitorController.php:165
* @route '/menu/{slug}'
*/
menuItemShowForm.head = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: menuItemShow.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

menuItemShow.form = menuItemShowForm

/**
* @see \App\Http\Controllers\ReservationController::roomsShow
* @see app/Http/Controllers/ReservationController.php:30
* @route '/rooms'
*/
export const roomsShow = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: roomsShow.url(options),
    method: 'get',
})

roomsShow.definition = {
    methods: ["get","head"],
    url: '/rooms',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ReservationController::roomsShow
* @see app/Http/Controllers/ReservationController.php:30
* @route '/rooms'
*/
roomsShow.url = (options?: RouteQueryOptions) => {
    return roomsShow.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ReservationController::roomsShow
* @see app/Http/Controllers/ReservationController.php:30
* @route '/rooms'
*/
roomsShow.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: roomsShow.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ReservationController::roomsShow
* @see app/Http/Controllers/ReservationController.php:30
* @route '/rooms'
*/
roomsShow.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: roomsShow.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ReservationController::roomsShow
* @see app/Http/Controllers/ReservationController.php:30
* @route '/rooms'
*/
const roomsShowForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: roomsShow.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ReservationController::roomsShow
* @see app/Http/Controllers/ReservationController.php:30
* @route '/rooms'
*/
roomsShowForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: roomsShow.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ReservationController::roomsShow
* @see app/Http/Controllers/ReservationController.php:30
* @route '/rooms'
*/
roomsShowForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: roomsShow.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

roomsShow.form = roomsShowForm

/**
* @see \App\Http\Controllers\ReservationController::tablesShow
* @see app/Http/Controllers/ReservationController.php:74
* @route '/tables'
*/
export const tablesShow = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: tablesShow.url(options),
    method: 'get',
})

tablesShow.definition = {
    methods: ["get","head"],
    url: '/tables',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ReservationController::tablesShow
* @see app/Http/Controllers/ReservationController.php:74
* @route '/tables'
*/
tablesShow.url = (options?: RouteQueryOptions) => {
    return tablesShow.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ReservationController::tablesShow
* @see app/Http/Controllers/ReservationController.php:74
* @route '/tables'
*/
tablesShow.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: tablesShow.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ReservationController::tablesShow
* @see app/Http/Controllers/ReservationController.php:74
* @route '/tables'
*/
tablesShow.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: tablesShow.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ReservationController::tablesShow
* @see app/Http/Controllers/ReservationController.php:74
* @route '/tables'
*/
const tablesShowForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: tablesShow.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ReservationController::tablesShow
* @see app/Http/Controllers/ReservationController.php:74
* @route '/tables'
*/
tablesShowForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: tablesShow.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ReservationController::tablesShow
* @see app/Http/Controllers/ReservationController.php:74
* @route '/tables'
*/
tablesShowForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: tablesShow.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

tablesShow.form = tablesShowForm

/**
* @see \App\Http\Controllers\ReservationController::reservationsStore
* @see app/Http/Controllers/ReservationController.php:118
* @route '/reservations'
*/
export const reservationsStore = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reservationsStore.url(options),
    method: 'post',
})

reservationsStore.definition = {
    methods: ["post"],
    url: '/reservations',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ReservationController::reservationsStore
* @see app/Http/Controllers/ReservationController.php:118
* @route '/reservations'
*/
reservationsStore.url = (options?: RouteQueryOptions) => {
    return reservationsStore.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ReservationController::reservationsStore
* @see app/Http/Controllers/ReservationController.php:118
* @route '/reservations'
*/
reservationsStore.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reservationsStore.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ReservationController::reservationsStore
* @see app/Http/Controllers/ReservationController.php:118
* @route '/reservations'
*/
const reservationsStoreForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reservationsStore.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ReservationController::reservationsStore
* @see app/Http/Controllers/ReservationController.php:118
* @route '/reservations'
*/
reservationsStoreForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reservationsStore.url(options),
    method: 'post',
})

reservationsStore.form = reservationsStoreForm

/**
* @see \App\Http\Controllers\SurveyController::survey
* @see app/Http/Controllers/SurveyController.php:24
* @route '/survey'
*/
export const survey = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: survey.url(options),
    method: 'get',
})

survey.definition = {
    methods: ["get","head"],
    url: '/survey',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SurveyController::survey
* @see app/Http/Controllers/SurveyController.php:24
* @route '/survey'
*/
survey.url = (options?: RouteQueryOptions) => {
    return survey.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SurveyController::survey
* @see app/Http/Controllers/SurveyController.php:24
* @route '/survey'
*/
survey.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: survey.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SurveyController::survey
* @see app/Http/Controllers/SurveyController.php:24
* @route '/survey'
*/
survey.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: survey.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SurveyController::survey
* @see app/Http/Controllers/SurveyController.php:24
* @route '/survey'
*/
const surveyForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: survey.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SurveyController::survey
* @see app/Http/Controllers/SurveyController.php:24
* @route '/survey'
*/
surveyForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: survey.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SurveyController::survey
* @see app/Http/Controllers/SurveyController.php:24
* @route '/survey'
*/
surveyForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: survey.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

survey.form = surveyForm
